import DashboardFilters from "../../../_dashboard-filters";
import { mapState } from "vuex";
import i18n from "../../../../plugins/i18n";
import { StatusTypes } from "../../../../constants/status_types";

export default {
  name: "StatesFilter",
  props: { setMainFilter: Function, selectedFilter: Object },
  components: { DashboardFilters },

  data() {
    return {
      // Highlighted filters
      mainOptions: [
        {
          filter: "allCows",
          name: i18n.t("dashboardView.states.allCows"),
          icon: "action-list/msyst-icon_cows-blue"
        },
        {
          filter: "lactating",
          name: i18n.t("dashboardView.states.lactating"),
          icon: "action-list/msyst-icon_lactating"
        },
        {
          filter: "nonLactating",
          name: i18n.t("dashboardView.states.nonLactating"),
          icon: "action-list/msyst-icon_dry-off"
        }
      ],

      // Filters
      options: [
        {
          filter: StatusTypes.VoluntaryWaitingPeriod,
          name: i18n.t(`cowGenerics.cowLogs.${StatusTypes.VoluntaryWaitingPeriod}`),
          icon: "messages/msyst-icon_all-messages-orange"
        },
        {
          filter: StatusTypes.ReproPeriod,
          name: i18n.t(`cowGenerics.cowLogs.${StatusTypes.ReproPeriod}`),
          icon: "messages/msyst-icon_health-orange"
        },
        {
          filter: StatusTypes.Inseminated,
          name: i18n.t(`cowGenerics.cowLogs.${StatusTypes.Inseminated}`),
          icon: "messages/msyst-icon_feeding-orange"
        },
        {
          filter: StatusTypes.Pregnant,
          name: i18n.t(`cowGenerics.cowLogs.${StatusTypes.Pregnant}`),
          icon: "messages/msyst-icon_fertility-orange"
        },
        {
          filter: StatusTypes.Dry,
          name: i18n.t(`cowGenerics.cowLogs.${StatusTypes.Dry}`),
          icon: "messages/msyst-icon_increased-activity-orange"
        },
        {
          filter: StatusTypes.Cull,
          name: i18n.t(`cowGenerics.cowLogs.${StatusTypes.Cull}`),
          icon: "messages/culled"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      summary: state => state.states.totals
    })
  }
};



// WEBPACK FOOTER //
// ./src/components/_dashboard/states/filter/states-filter.js